import React from 'react';
import './Modal.scss';

function Modal(props) {

  const modalToggler = () => {
    document.querySelector('.Modal #contact #error-text').innerHTML = ''
    props.modalToggler("", "")
  }

  const GAEvent = (event) => {
    if (document.location.hostname.indexOf("flex.basler.com") > -1) {
      window.gtag('event', event)
    }
  }

  const downloadResource = () => {
    let valid = true
    document.querySelectorAll('.Modal #download div.field-group input[type="text"]').forEach(input => {
      if (input.value.trim() === "") {
        valid = false
        input.style.border = "2px solid red"
      } else {
        input.style.border = "1px solid #666666"
      }
    })

    if (valid === true) {
      GAEvent(props.name)
      modalToggler()
      let link = document.createElement('a')
      link.style.display = "none"
      let href = "https://www.basler.com/ResourceAPI.aspx?campaign=" + encodeURIComponent("BE1-FLEX Microsite")
      href += "&code=" + encodeURIComponent(props.code)
      href += "&email=" + encodeURIComponent(document.querySelector('.Modal #download #email-input').value)
      href += "&firstName=" + encodeURIComponent(document.querySelector('.Modal #download #first-input').value)
      href += "&lastName=" + encodeURIComponent(document.querySelector('.Modal #download #last-input').value)
      href += "&company=" + encodeURIComponent(document.querySelector('.Modal #download #company-input').value)
      href += "&medium=" + encodeURIComponent("Download")
      href += "&optIn=" + encodeURIComponent(document.querySelector('.Modal #download #opt-input').checked)
      href += "&contact=" + encodeURIComponent(document.querySelector('.Modal #download #contact-input').checked)
      link.href = href
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
  
  const submitContact = () => {
    let valid = true
    document.querySelectorAll('.Modal #contact div.field-group input[type="text"]').forEach(input => {
      if (input.value.trim() === "") {
        valid = false
        input.style.border = "2px solid red"
      } else {
        input.style.border = "1px solid #666666"
      }
    })

    if (valid === true) {
      GAEvent('Live Simulation Request')
      let link = document.createElement('a')
      link.style.display = "none"
      let href = ""
      if (document.location.hostname.indexOf("flex-test.basler.com") > -1) {
        href = "https://new.basler.com/ContactAPI.asmx/contact"
      } else if (document.location.hostname.indexOf("flex.basler.com") > -1) {
        href = "https://www.basler.com/ContactAPI.asmx/contact"
      }
      
      let body = "campaign=" + encodeURIComponent("BE1-FLEX Microsite")
      body += "&email=" + encodeURIComponent(document.querySelector('.Modal #contact #email-input').value)
      body += "&firstName=" + encodeURIComponent(document.querySelector('.Modal #contact #first-input').value)
      body += "&lastName=" + encodeURIComponent(document.querySelector('.Modal #contact #last-input').value)
      body += "&company=" + encodeURIComponent(document.querySelector('.Modal #contact #company-input').value)
      body += "&medium=" + encodeURIComponent("Contact Request")
      body += "&optIn=" + encodeURIComponent(document.querySelector('.Modal #contact #opt-input').checked)
      body += "&contactIn=" + encodeURIComponent("true")
      
      fetch(href, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: body
      })
      .then(res => {
        modalToggler()
      })
      .catch(err => {
        document.querySelector('.Modal #contact #error-text').innerHTML = 'There was an error processing your request. If you would still like to make a request, you can contact your direct salesperson using the <a href="https://www.basler.com/Support/">support page</a>.'
      })
    }
  }

  return (
    <div className={'Modal ' + props.windowSize + ' ' + props.visible}>
      <div className="modal-container">
        <div className={"group " + (props.view === "download" ? "active" : "")} id="download">
          <h2>Download Resource</h2>
          <div className="field-group" id="error">
            <label id="error-text"></label>
          </div>
          <div className="field-group">
            <label>Email</label>
            <input id="email-input" type="text" />
          </div>
          <div className="field-group">
            <label>First Name</label>
            <input id="first-input" type="text" />
          </div>
          <div className="field-group">
            <label>Last Name</label>
            <input id="last-input" type="text" />
          </div>
          <div className="field-group">
            <label>Company</label>
            <input id="company-input" type="text" />
          </div>
          <div id="first-check" className="field-group">
            <input id="opt-input" type="checkbox" />
            <label>Receive new product updates and more from Basler.</label>
          </div>
          <div className="field-group">
            <input id="contact-input" type="checkbox" />
            <label>I would like to be contacted by an Application Engineer.</label>
          </div>
          <div className="field-group">
            <button id="download-submit" onClick={() => downloadResource()}>Download Resource</button>
            <button onClick={() => modalToggler()}>Cancel</button>
          </div>
        </div>
        <div className={"group " + (props.view === "contact" ? "active" : "")} id="contact">
          <h2>Request a Live Simulation</h2>
          <div className="field-group" id="error">
            <label id="error-text"></label>
          </div>
          <div className="field-group">
            <label>Email</label>
            <input id="email-input" type="text" />
          </div>
          <div className="field-group">
            <label>First Name</label>
            <input id="first-input" type="text" />
          </div>
          <div className="field-group">
            <label>Last Name</label>
            <input id="last-input" type="text" />
          </div>
          <div className="field-group">
            <label>Company</label>
            <input id="company-input" type="text" />
          </div>
          <div id="first-check" className="field-group">
            <input id="opt-input" type="checkbox" />
            <label>Receive new product updates and more from Basler.</label>
          </div>
          <div className="field-group">
            <button id="contact-submit" onClick={() => submitContact()}>Submit</button>
            <button onClick={() => modalToggler()}>Cancel</button>
          </div>
        </div>
        <div className={"group " + (props.view === "protection" ? "active" : "")} id="protection">
          <div className="close-button">
            <button onClick={() => modalToggler()}>Close</button>
          </div>
          <h2>B) Basic Current</h2>
          <div className="field-group">
            <ul>
              <li>43</li>
              <li>46</li>
              <li>49RTD</li>
              <li>50</li>
              <li>51</li>
              <li>51TF</li>
              <li>51V</li>
              <li>62</li>
              <li>67</li>
              <li>76</li>
              <li>79</li>
              <li>86</li>
              <li>87FB</li>
              <li>101</li>
              <li>Breaker Fail</li>
              <li>Breaker</li>
              <li>Monitor</li>
            </ul>
          </div>
          <h2>C) Basic Voltage</h2>
          <div className="field-group">
            <ul>
              <li>27</li>
              <li>43</li>
              <li>47</li>
              <li>49RTD</li>
              <li>59</li>
              <li>62</li>
              <li>79</li>
              <li>81</li>
              <li>86</li>
              <li>101</li>
            </ul>
          </div>
          <h2>D) Intermediate</h2>
          <div className="field-group">
            <ul>
              <li>Basic Current</li>
              <li>Basic Voltage</li>
              <li>24</li>
              <li>25</li>
              <li>32</li>
              <li>37</li>
              <li>40Q</li>
              <li>40Z</li>
              <li>55</li>
              <li>66</li>
              <li>78V</li>
              <li>78OOS</li>
              <li>81A</li>
              <li>Configurable Protection</li>
            </ul>
          </div>
          <h2>E) Enhanced</h2>
          <div className="field-group">
            <ul>
              <li>Intermediate</li>
              <li>21P</li>
              <li>21N</li>
              <li>25A</li>
              <li>87</li>
              <li>87N</li>
            </ul>
          </div>
        </div>
        <div className={"group " + (props.view === "protocol" ? "active" : "")} id="protocol">
          <div className="close-button" style={{position: "fixed", right: "10px", top: "25px"}}>
            <button onClick={() => modalToggler()}>Close</button>
          </div>
          <h2>00) Standard</h2>
          <div className="field-group">
            <ul>
              <li>BESTnet&trade; <i>Plus</i></li>
              <li>Email Alerts</li>
            </ul>
          </div>
          <h2>01) Package 01</h2>
          <div className="field-group">
            <ul>
              <li>Standard Package</li>
              <li>Modbus&reg;/RTU</li>
              <li>Modbus&reg;/TCP</li>
              <li>DNP3</li>
              <li>Synchrophasors IEEE C37.118.2 - P Class</li>
            </ul>
          </div>
          <h2>02) Package 02</h2>
          <div className="field-group">
            <ul>
              <li>Package 1</li>
              <li>IEC 61850</li>
            </ul>
          </div>
        </div>
        <div className="group">

        </div>
        <div className="group">

        </div>
      </div>
    </div>
  );
}

export default Modal;